// extracted by mini-css-extract-plugin
module.exports = {"customListCard":"CustomLists_customListCard__1csNV","customListCardBody":"CustomLists_customListCardBody__3LcoW","buttonsContainer":"CustomLists_buttonsContainer__GYISf"};